<!-- 拖拽式 可上传多张图片的 -->
<template>
	<div class="drag-upload">
		<el-upload
			class="upload-demo"
			list-type="picture"
			:data="additionalData"
			:headers="headers"
			:action="uploadImgUrl"
			:before-upload="handleBeforeUpload"
			:on-success="handleUploadSuccess"
			:on-preview="handlePreview"
			multiple
			drag>
			<el-icon class="el-icon--upload">
				<upload-filled />
			</el-icon>
			<div class="el-upload__text">
				将文件拖到此处，或
				<em>点击上传</em>
			</div>
			<template #tip>
				<div class="el-upload__tip">只能上传{{ fileType.join('/') }}文件，且不超过{{ fileSize }}M</div>
			</template>
		</el-upload>

		<el-dialog v-model="dialogVisible">
			<img w-full :src="dialogImageUrl" alt="Preview Image" />
		</el-dialog>
	</div>
</template>

<script setup>
import { getToken } from '@/utils/auth'
import { checkFileUpload } from '@/utils/scm'
import { useImageUrl } from '@/utils/dynamic'
import defaultSettings from '@/settings'
import defaultImgs from '@/images'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
	modelValue: [String, Object, Array],
	// 图片数量限制
	limit: {
		type: Number,
		default: 5
	},
	// 大小限制(MB)
	fileSize: {
		type: Number,
		default: 5
	},
	// 文件类型, 例如['png', 'jpg', 'jpeg']
	fileType: {
		type: Array,
		default: () => ['png', 'jpg', 'jpeg', 'gif']
	},
	// 是否显示提示
	isShowTip: {
		type: Boolean,
		default: true
	}
})

const uploadImgUrl = ref(defaultSettings.fileUploadUrl) // 上传的图片服务器地址

const imageUrl = ref(defaultImgs.defaultImg)
const additionalData = ref({
	belongApp: defaultSettings.app,
	belongAppId: defaultSettings.appId
})

const headers = ref({ Authorization: 'Bearer ' + getToken() })

const dialogImageUrl = ref('')
const dialogVisible = ref(false)

//使用 before-upload 限制用户上传的图片格式和大小
function handleBeforeUpload(file) {
	return checkFileUpload(file, props.fileType, props.fileSize)
}

//上传成功, 数据双向绑定
function handleUploadSuccess(res, file) {
	if (res.ResData) {
		imageUrl.value = res.ResData.FilePath
		emit('update:modelValue', imageUrl.value)
	}
}

// 预览
function handlePreview(file) {
	dialogImageUrl.value = file.url
	dialogVisible.value = true
}

// 因为props.modelValue是非引用类型，改变时，需要监听，对响应式数据重新赋值
watch(
	() => props.modelValue,
	(val) => {
		if (val != null && val != '') {
			//如果是远程文件则直接赋值
			imageUrl.value = useImageUrl(props.modelValue)
		} else if (imageUrl.value != null && imageUrl.value != '') {
			emit('update:modelValue', imageUrl.value)
		}
	},
	{
		immediate: true,
		deep: true
	}
)
</script>

<style scoped lang="scss">
.drag-upload {
	width: 100%;

	.upload-demo {
		width: 100%;

		.is-drag {
			float: left;
			width: 290px;
			padding: 10px;

			.el-upload-dragger {
				padding: 10px 5px !important;
			}
		}
		.el-upload__tip {
			padding-top: 5px;
		}

		.el-upload-list--picture {
			.el-upload-list__item {
				border: 1px solid #e4e7ed;
				float: left;
				width: 100px;
				height: 100px;
				margin: 0px 2px;
				text-align: center;
				z-index: 10;

				.el-upload-list__item-status-label {
					z-index: 20;
				}
			}
		}
	}
}
</style>
